<template>
  <b-container class="topheader sticky-top"
               fluid>
    <b-row id="topbar">
      <!-- Column 1 -->
      <b-col class="d-flex align-items-center justify-content-start">
        <!-- Sidebar toggler -->
        <a role="button"
           v-if="!hideToggle"
           @click="toggleSidebar"
           class="sidebar-toggler mr-3">
          <i class="fa fa-outdent"></i>
        </a>
        <!-- /Sidebar toggler -->

        <!-- Logo -->
        <div id="sysname"
             class="font-italic mr-3"
             v-if="!esg">
          <a role="button"
             @click="goDashboard"
             :class="isHidden ? 'd-none' : ''">
            <img class="topbar-logo"
                 src="@/assets/images/spade-logo.png">
          </a>
        </div>
        <!-- /Logo -->

        <!-- User info -->
        <a href="#"
           class="d-none d-md-block user-detail"
           @click="showUserDetail()">
          <b-avatar class="secondary mr-2"
                    v-if="currentUser().profileImg && currentUser().profileImg != ''"
                    :src="'data:image/'+currentUser().profileImgName.substr(currentUser().profileImgName.lastIndexOf('.'))+';base64,' + currentUser().profileImg"></b-avatar>
          <b-avatar class="secondary mr-2"
                    v-else
                    :text="currentUser().caller.substring(0,1)"></b-avatar>
          <span>{{ currentUser().caller }}</span>
        </a>

        <b-badge @click="showNotification"
                 variant="primary"
                 class="d-md-flex align-items-center mr-1 btn d-none"
                 style="margin-left: 7px;"
                 v-if="currentUser()">
          <b-icon icon="bell-fill"></b-icon>
          <span class="notification-badge"
                style="margin-left:5px;">{{ notificationCount }}</span>
        </b-badge>
        <!-- /User info -->
      </b-col>
      <!-- /Column 1 -->

      <!-- Column 2 -->
      <b-col class="d-sm-flex justify-content-end align-items-center d-none">
        <!-- Navigation -->
        <div class="d-flex align-items-center mr-sm-3"
             v-if="currentUser()">
          <b-badge @click="redirect($event)"
                   class="btn mr-1"
                   v-for="role in roles()"
                   :key="role">{{ role }}
          </b-badge>
        </div>
        <!-- /Navigation -->

        <!-- Sign out button -->
        <div id="sign"
             class="mr-2">
          <a role="button"
             @click="goSign"
             class="btn btn-primary">{{ showSign() }}</a>
        </div>
        <!-- /Sign out button -->
      </b-col>
      <!-- /Column 2 -->
    </b-row>

    <!--Detail modal start-->
    <b-modal size="lg"
             ref="modalUserInfo"
             header-class="detail-header"
             title="User Information"
             ok-only
             ok-variant="secondary"
             ok-title="Close"> <!-- size = xl, lg, sm -->
      <table class="table table-striped table-bordered table-hover shadow-sm mt-2">
        <loading :active.sync="detailPopupLoading"
                 :can-cancel="false"
                 :is-full-page="false"></loading>
        <thead class="script-header">
        <tr class="text-center">
          <th>Item</th>
          <th>Value</th>
          <th>Update</th>
        </tr>
        </thead>
        <tbody>
          <tr>
            <th>User ID</th>
            <td>
              <div class="form-group mr-2 flex-grow-1">
                <input readonly
                      class="form-control"
                      name="userId"
                      v-model="user.userId">
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            <th>User Name</th>
            <td>
              <div class="mr-2 flex-grow-1">
                <input readonly
                      class="form-control"
                      name="userName"
                      v-model="user.userName">
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            <th>Mobile</th>
            <td>
              <div class="mr-2 flex-grow-1">
                <input class="form-control" v-model="user.mobile" placeholder="숫자만 입력해주세요">
              </div>
            </td>
            <td class="text-center">
              <button type="button" class="btn btn-success" @click="updateUserInfo('mobile')">Update</button>
            </td>
          </tr>
          <tr>
            <th>Profile Image</th>
            <td align-self="center">
              <div class="form-group mr-2 flex-grow-1">
                <b-form-file ref="file-input"
                            id="file-input"
                            @input="addFile"
                            v-model="user.file"
                            accept="image/*"
                            placeholder="Choose a file or drop it here"
                            drop-placeholder="Drop a file here"></b-form-file>
              </div>
            </td>
            <td class="text-center">
              <button type="button"
                      class="btn btn-success"
                      v-on:click="updateProfileImg()">Update
              </button>
            </td>
          </tr>
          <tr>
            <th>Preferred Role</th>
            <td>
              <div class="form-group mr-2 flex-grow-1"
                  v-if="roleList">
                <select class="form-control"
                        v-model="user.preferRole"
                        name="preferredRole">
                  <option value=""></option>
                  <option v-for="role in roleList"
                          :value="role"
                          :key="role">{{ role }}
                  </option>
                </select>
                <div class="alert-danger"
                    v-if="submitted && errors.has('preferredRole')">
                  {{ errors.first('preferredRole') }}
                </div>
              </div>
            </td>
            <td class="text-center">
              <button type="button"
                      class="btn btn-success"
                      v-on:click="updateUserInfo('role')">{{ 'Update' }}
              </button>
            </td>
          </tr>
          <tr>
            <th>Password</th>
            <td>
              <div class="form-group mr-2 flex-grow-1">
                <input type="password"
                      class="form-control"
                      name="password"
                      v-model="user.password"
                      v-validate="'min:6|max:40'"
                      @keypress="showReEnterField(user.password)">
                <div class="alert-danger"
                    v-if="submitted && errors.has('password')">{{
                    errors.first('password')
                  }}
                </div>
              </div>
            </td>
            <td class="text-center">
              <button type="button"
                      class="btn btn-success"
                      v-on:click="updateUserInfo('password')">{{ 'Update' }}
              </button>
            </td>
          </tr>
          <tr>
            <th>Password 확인</th>
            <td>
              <div class="form-group mr-2 flex-grow-1">
                <input type="password"
                      class="form-control"
                      name="rePassword"
                      v-model="user.rePassword"
                      v-validate="'min:6|max:40'">
                <div class="alert-danger"
                    v-if="submitted && rePasswordErrorFlag">{{ rePasswordError }}
                </div>
              </div>
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </b-modal>
    <!--Detail modal end -->


    <b-modal size="lg"
             ref="modalNotification"
             header-class="detail-header"
             title="Chatter Notification Message"
             ok-only
             ok-variant="secondary"
             ok-title="Close"> <!-- size = xl, lg, sm -->
      <table class="table table-striped table-bordered table-hover shadow-sm mt-2">
        <loading :active.sync="requestNotificationLoading"
                 :can-cancel="false"
                 :is-full-page="false"></loading>
        <colgroup>
          <col width="13%"/>
          <col width="8%"/>
          <col width="45%"/>
          <col width="10%"/>
          <col width="24%"/>
        </colgroup>
        <thead class="script-header">
        <tr class="text-center">
          <th style="vertical-align: middle;">Chatter ID</th>
          <th style="vertical-align: middle;">Type</th>
          <th style="vertical-align: middle;">Chatter Title</th>
          <th style="vertical-align: middle;">Status</th>
          <th style="vertical-align: middle;">Update Date</th>
        </tr>
        </thead>
        <tbody>
          <router-link tag="tr" :to="`/chatter/edit/${chat.chatId}`" v-for="chat in chatList" :key="chat.chatId">
            <td class="text-center"
                style="vertical-align: middle;">{{ chat.chatId }}
            </td>
            <td class="text-center"
                style="vertical-align: middle;">{{ chat.type }}
            </td>
            <td style="vertical-align: middle;">{{ chat.title }}</td>
            <td class="text-center"
                style="vertical-align: middle;">{{ chat.status }}
            </td>
            <td class="text-center"
                style="vertical-align: middle;">{{ chat.updatedDate }}
            </td>
          </router-link>
        </tbody>
      </table>
    </b-modal>

  </b-container>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import {Encrypt} from '@//utils.js'
import SockJS from 'sockjs-client';
import Stomp from "stompjs"
import { faPersonBooth } from '@fortawesome/free-solid-svg-icons';

export default {
  name: 'TopBar',
  props: {
    msg: String,
    hideToggle: {
      type: Boolean,
      default: false
    },
    esg: {
      type: Boolean,
      default: false
    }
  },
  components: {Loading},
  async created() {
    try {
      // Role이 Chatterer인 사용자만 notification 조회 or 웹소켓 연결
      if (this.currentUser().roles.includes('Chatterer')) {
        this.openWebSocket();
        this.getNotification();
        // this.notificationInterval = setInterval(this.getNotification, 20000);
      }

      // TobBar 최초 생성 시 모든 프로젝트 정보 조회 후 Vuex에 저장
      this.$store.dispatch('chatter/retrieveAllProjectInfo');
    } catch (e) {
      await this.showError(e)
    }
  },
  beforeDestroy() {
    // clearInterval(this.notificationInterval);
  },
  data() {
    return {
      user: {
        tenantId: '',
        userId: '',
        userName: '',
        mobile: '',
        password: '',
        rePassword: '',
        preferRole: ''
      },
      notificationInterval: null,
      submitted: false,
      successful: false,
      message: '',
      submitted: true,
      isHidden: true,
      detailPopupLoading: false,
      showDetailLoading: false,
      rePasswordVisible: false,

      roleList: [],
      beforeRole: '',

      rePasswordErrorFlag: false,
      rePasswordError: 'Password does not match.',

      //230607 추가
      requestNotificationLoading: false,
      chatList: [],
    }
  },
  computed: {
    notificationCount() {
      return this.$store.getters['chatter/getNotificationCount'];
    },
  },
  methods: {
    openWebSocket() {

      this.socket = new SockJS(WORKMAN_URL + "chatterer", {transports: ['websocket']});

      // console.log(this.currentUser);
      this.stompClient = Stomp.over(this.socket);
      this.stompClient.debug = null;
      this.stompClient.connect({ Authorization: accessToken()}, () => {
        this.stompClient.subscribe('/user/queue/chatter/notification', (message)=>{
          this.$store.commit('chatter/mergeNotifications', JSON.parse(message.body));
        });
      })
    },
    isAdmin() {
      return this.hasAnyRole('Administrator');
    },
    currentUser() {
      return this.$store.getters['auth/currentUser'];
    },
    redirect(event) {
      let role = event.target.innerText;

      if (['Supervisor', 'Administrator'].includes(role)) {
        this.pushRoute('/admin')
      } else if (['Operator'].includes(role)) {
        this.pushRoute('/dashboard');
      } else if (['Chatterer'].includes(role)) {
        this.pushRoute('/chatter');
      } else if (['Surveyor'].includes(role)) {
        this.pushRoute('/survey');
      } else if (['ESG'].includes(role)) {
        this.pushRoute('/esg');
      } else {
        this.pushRoute('/dashboard');
      }
    },
    goDashboard() {
      if (this.hasAnyRole('Supervisor')) {
        this.pushRoute('/admin');
      } else if (this.hasAnyRole('Surveyor')) {
        this.pushRoute('/survey');
      } else if (this.hasAnyRole("Chatterer")) {
        this.pushRoute('/chatter');
      } else {
        this.pushRoute('/dashboard');
      }
    },
    goSign() {
      if (this.$router.currentRoute.name === 'signup') {
        this.pushRoute('signin');
      } else if (this.$router.currentRoute.name === 'signin') {
        this.pushRoute('signup');
      } else {
        this.$store.dispatch('auth/logout');
        this.pushRoute('/signin');
      }
    },
    showSign() {
      if (this.$router.currentRoute.name === 'signup') {
        return 'Sign In';
      } else if (this.$router.currentRoute.name === 'signin') {
        return 'Sign Up';
      } else {
        return 'Sign Out';
      }
    },
    toggleSidebar() {
      this.isHidden = !this.isHidden;
      this.$parent.toggleSidebar();
    },
    showUserDetail() {
      if (this.user.tenantId == '') {
        let userInfo = this.$store.getters['auth/currentUser'];
        this.user.tenantId = userInfo.tenant;
        this.user.userId = userInfo.caller;
        this.user.userName = userInfo.userkorname; 
        this.user.mobile = userInfo.mobile; 
        this.user.preferRole = userInfo.preferRole;
        this.user.profileImg = userInfo.profileImg;
        this.roleList = userInfo.roles;

        this.beforeRole = userInfo.preferRole;
      }
      this.$refs['modalUserInfo'].show();
    },
    // showNotification(){
    //   if(this.notificationCount()==0)return;
    //   this.$refs['modalNotification'].show();
    //   this.retrieveChatList();
    // },
    showNotification() {
      if (this.notificationCount == 0) return;

      if (this.$route.path == '/chatter') {
        this.$store.commit('chatter/resetFilter');
        this.$store.commit('chatter/setUpdated', 'Y');
      } else {
        this.$refs['modalNotification'].show();
        this.retrieveChatList();
      }

    },
    showReEnterField(password) {
      if (this.rePasswordVisible === false) {
        this.rePasswordVisible = true;
      }
    },
    async updateUserInfo(type) {

      this.submitted = true;
      this.detailPopupLoading = true;

      //let returnFlag = false;
      // Update confirmation
      let encrynped = '';

      const cloneObj = obj => JSON.parse(JSON.stringify(obj));
      let updateData = cloneObj(this.user);

      //let message = '';

      if (type == 'password') {
        if (updateData.password == '' || updateData.rePassword == '') {
          this.showMessage("패스워드를 입력해주세요.");``
          this.detailPopupLoading = false;
          return;
        }
        if ((updateData.rePassword == null || updateData.rePassword === '') || updateData.rePassword.trim() !== updateData.password.trim()) {
          this.rePasswordErrorFlag = true;
          this.rePasswordError = 'Password does not match.'
          this.detailPopupLoading = false;
          return;
        }
        encrynped = Encrypt(updateData.password); //패스워드 암호화
      } else if (type == 'role') {
        if (updateData.preferRole == '') {
          this.showMessage("Role을 선택해주세요.");
          this.detailPopupLoading = false;
          return;
        }
        if (this.beforeRole == updateData.preferRole) {
          this.showMessage("Role이 동일합니다.");
          this.detailPopupLoading = false;
          return;
        }
      } else if (type == 'mobile') {
        const pattern = /^\d{11}$/;
        if(!updateData.mobile) {
          this.showMessage("번호를 입력해주세요.");
          return;
        } else if(!pattern.test(updateData.mobile)) {
          this.showMessage("숫자 11자리로 입력해주세요.");
          return;
        }
      }

      this.$validator.validate().then(async valid => {
        if (valid) {
          let params = {
            tenantId: updateData.tenantId,
            userId: updateData.userId,
            userName: updateData.userName,
            preferRole: updateData.preferRole,
            password: encrynped,
            mobile: updateData.mobile
          };

          try {
            await axios.post('auth/updateUserInfo', params, {
              headers: {
                'Accept': 'application/json',
                'Authorization': accessToken()
              },
              responseType: "blob"
            });

            this.showMessage('정상적으로 변경되었습니다.');
            this.user.password = '';
            this.user.rePassword = '';
            this.beforeRole = updateData.preferRole;
            this.mobile = updateData.mobile;
          } catch (error) {
            this.showError(error.message);
          } finally {
            this.detailPopupLoading = false;
            this.submitted = false;
          }
        }
      });
    },
    getNotification() {
      axios.get(WORKMAN_URL + "chatter/notifications", {
        headers: {
          Authorization: accessToken(),
          Accept: "application/json"
        }
      })
          .then(response => {
            this.$store.commit('chatter/setNotifications', response.data);
          })
          .catch(async error => {
            await this.showError(error);
          });
    },
    async retrieveChatList() {
      this.requestNotificationLoading = true;
      // Set parameters
      this.chatList = [];

      // Load chats
      let params = {
        pageSize: 0,
        retrieveType: "UPDATED"
      };
      try {
        let response = await axios.post('/chatter/retrieveChatterList', params, {
          headers: {
            Authorization: accessToken()
          }
        });

        const status = response.data.status;
        if(status === "200") {
          const body = response.data.body;
          body.list.forEach((item) => {
            this.chatList.push(item);
          });

          // Sort chatList in descending order
          this.chatList.sort((a, b) => new Date(b.updatedDate) - new Date(a.updatedDate));
        }

      } catch (error) {
        await this.showError(error);
      } finally {
        this.requestNotificationLoading = false;
      }
    },
    showChatDetail(chatId) {
      this.pushRoute({name: "chatDetail", params: {id: chatId}});
      this.$refs['modalNotification'].hide();
    },
    addFile() {
      if (!this.file) return;

      // Clone the file input
      const original = this.file;
      const clone = new File([original], original.name, {
        type: original.type,
        lastModified: original.lastModified,
      });
      this.user.file = clone;
      this.user.fileName = original.name;

      this.$refs["file-input"].reset();
    },
    updateMobile() {

    },
    async updateProfileImg() {
      let data = new FormData();
      data.append("file", this.user.file);
      await axios.post("auth/updateProfileImg", data, {
        headers: {
          Accept: "application/json",
          Authorization: accessToken(),
          "Content-Type": "multipart/form-data",
        },
        responseType: "json"
      }).then(response => {
        if (response.data) {
          this.$store.commit("auth/setUserProfile", response.data);
          this.showMessage('정상적으로 변경되었습니다.');
        }
      }).catch((error) => {
        this.showErrorMessage(error);
      });
    }
  },
}
</script>

<style scoped>
#sysname a {
  display: block;
}

#topbar {
  padding: 0;
  align-items: center;
}

.sidebar-toggler {
  font-size: 28px;
  color: #304156;
}

.user-detail {
  text-decoration: none;
  color: black;
}

.table th, td {
  margin: 0px;
  vertical-align: middle !important;
}

.form-control, .form-group {
  margin: 0px;
}
</style>
